<template>
  <div class="q-col-12 q-col-sm-6 q-col-md-3 q-d-block q-d-md-none q-pb-3 q-pb-sm-0 q-p-0 q-p-sm-1">
    <button type="button"
            class="q-btn q-btn q-btn-danger q-rounded-3 q-shadow-sm"
            id="showFiltersOnMobile"
            @click="filtersStore.showFiltersOnMobile"
    >
      {{ SmartSearchTranslations.filters.show}}
    </button>
  </div>
</template>

<script setup lang="ts">
import {inject} from "vue";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
const filtersStore = useFiltersStore();
import {SmartSearchTranslationsInterface} from "@/core/types";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

</script>


<style scoped>
button{
  width: 100%;
}

</style>
